import { MeetingDayDto, MeetingEventTypeDto, MeetingStatusDto } from '@/api/generated';
import { MeetingsViewTranslation } from '@/assets/locales/views/meetings/meetings.translation.en.ts';

export const meetingsViewTranslation: MeetingsViewTranslation = {
  body: {
    details: 'Szczegóły',
    moreParticipants: 'i jeszcze {{count}}',
    noteSent: 'Wysłano',
    sendToErecruiter: 'Wyślij do eRecruitera',
  },
  columns: {
    actions: 'Akcje',
    participants: 'Uczestnicy',
    recruitment: 'Rekrutacja',
    startAt: 'Początek',
    status: 'Status',
    subject: 'Temat',
  },
  days: {
    disabledHint: 'Nieaktywne, gdy wybrany jest zakres dat — wyczyść go, żeby wrócić do skrótów.',
    options: {
      [MeetingDayDto.Today]: 'Dziś',
      [MeetingDayDto.Tomorrow]: 'Jutro',
      [MeetingDayDto.Yesterday]: 'Wczoraj',
    },
  },
  details: {
    activity: 'Aktywność bota i systemu',
    addFeedback: 'Dodaj feedback',
    aiVersion: 'Wersja AI',
    aiVersionHint:
      'Wersja wygenerowana przez model, w oryginalnym brzmieniu. Została później zmieniona, więc nie da się jej wysłać — wróć do aktualnej.',
    automatically: 'automatycznie',
    cancelEdit: 'Anuluj',
    currentVersion: 'Aktualna',
    downloadDocument: 'Pobierz dokument (PDF)',
    downloadPdf: 'Pobierz PDF',
    duration: 'Czas trwania',
    editedAfterSend:
      'Notatka była edytowana po wysyłce. Wyślij ponownie, aby przekazać aktualną wersję do eRecruitera — trafi tam jako nowy wpis.',
    editHint:
      'Formatowanie: ## nagłówek sekcji, ### podnagłówek, - punktor, **pogrubienie**. Ten sam zapis trafia do PDF i do eRecruitera.',
    editNote: 'Edytuj',
    editPlaceholder: 'Treść notatki (Markdown)',
    events: {
      [MeetingEventTypeDto.BotInCall]: 'Bot na spotkaniu',
      [MeetingEventTypeDto.BotJoining]: 'Bot dołącza do spotkania',
      [MeetingEventTypeDto.BotLeft]: 'Bot opuścił spotkanie',
      [MeetingEventTypeDto.BotRecording]: 'Rozpoczęto nagrywanie',
      [MeetingEventTypeDto.EveryoneLeft]: 'Wszyscy opuścili spotkanie',
      [MeetingEventTypeDto.FeedbackAdded]: 'Dodano feedback',
      [MeetingEventTypeDto.FeedbackEdited]: 'Edytowano feedback',
      [MeetingEventTypeDto.MeetingFailed]: 'Spotkanie zakończone błędem',
      [MeetingEventTypeDto.NoteDocSent]:
        'Notatka wysłana do eRecruitera jako .docx (już nieużywane)',
      [MeetingEventTypeDto.NoteEdited]: 'Notatka edytowana',
      [MeetingEventTypeDto.NoteReady]: 'Notatka wygenerowana',
      [MeetingEventTypeDto.NoteSendFailed]: 'Wysyłka notatki nie powiodła się',
      [MeetingEventTypeDto.NoteSent]: 'Notatka wysłana do eRecruitera',
      [MeetingEventTypeDto.RecordingReady]: 'Nagranie gotowe',
      [MeetingEventTypeDto.Transcribing]: 'Transkrypcja w toku',
      [MeetingEventTypeDto.TranscriptFailed]: 'Transkrypcja nieudana',
      [MeetingEventTypeDto.TranscriptReady]: 'Transkrypt gotowy',
    },
    feedback: 'Feedback rekrutera',
    feedbackPlaceholder: 'Twój feedback po rozmowie',
    hideSent: 'ukryj wysłaną treść',
    joinMeeting: 'Dołącz do spotkania',
    language: 'Język rozmowy',
    lastEdited: 'Edytowano',
    metrics: {
      botLeaveDelay: 'Wszyscy wyszli → bot wyszedł',
      noteDelay: 'Wszyscy wyszli → notatka',
      recording: 'Czas nagrania',
      recordingHint: 'za tyle liczy Recall',
      transcriptDelay: 'Wszyscy wyszli → transkrypt',
    },
    noActivity: 'Brak zarejestrowanej aktywności',
    noFeedback: 'Brak feedbacku',
    noNote: 'Brak notatki',
    note: 'Notatka',
    noteSendFailed: 'Wysyłka do eRecruitera nie powiodła się',
    noteSent: 'Wysłano do eRecruitera',
    noTranscript: 'Brak transkryptu',
    participants: 'Uczestnicy',
    parts: {
      charsOfLimit: '{{total}} z {{max}} znaków',
      charsTotal: 'łącznie {{total}} znaków, limit {{max}} na część',
      draftChars: '{{chars}} znaków',
      draftCharsOfLimit: '{{chars}} / {{max}} znaków na część',
      fitsInOne: 'Zmieści się w jednej notatce eRecruitera',
      orderHint:
        'Części lecą od ostatniej do pierwszej, żeby w eRecruiterze czytały się od góry. Każda ma znacznik [1/n], który wlicza się do limitu.',
      partChars: '{{chars}} / {{max}} znaków',
      partLabel: 'Część {{number}} z {{count}}',
      splitInto: 'Zostanie wysłana w {{count}} częściach',
      title: 'Co trafi do eRecruitera',
    },
    recruitment: 'Rekrutacja',
    restoreAiVersion: 'Przywróć wersję AI',
    saveNote: 'Zapisz',
    sentInParts: 'wysłana w {{count}} częściach',
    showSent: 'pokaż wysłaną treść',
    startAt: 'Początek',
    transcript: 'Transkrypt',
    unknownAuthor: 'Nieznany autor',
  },
  filters: {
    dateFrom: 'Data od',
    dateTo: 'Data do',
    days: 'Szybkie filtry',
    organizers: 'Twórca spotkania',
    searchPhrase: 'Temat lub uczestnik...',
    statuses: 'Statusy',
  },
  statuses: {
    [MeetingStatusDto.Cancelled]: 'Odwołane',
    [MeetingStatusDto.Discovered]: 'Wykryte',
    [MeetingStatusDto.Failed]: 'Błąd',
    [MeetingStatusDto.InCall]: 'W trakcie',
    [MeetingStatusDto.Joining]: 'Dołącza',
    [MeetingStatusDto.NoteReady]: 'Notatka gotowa',
    [MeetingStatusDto.Recording]: 'Nagrywanie',
    [MeetingStatusDto.RecordingDone]: 'Nagranie gotowe',
    [MeetingStatusDto.Scheduled]: 'Zaplanowane',
    [MeetingStatusDto.Transcribing]: 'Transkrypcja',
    [MeetingStatusDto.TranscriptReady]: 'Transkrypt gotowy',
  },
};
